import { type DragEvent, type ReactNode } from 'react';
import { useRGContext } from '../../contexts';

const RGDroppable = (props: {
  id: string;
  type: string;
  initialSize: { w: number; h: number };
  metadata: object;
  node: ReactNode;
}) => {
  const { onDragStart, onDragStop } = useRGContext();

  const handleDragStart = (e: DragEvent) => {
    onDragStart(props.initialSize);

    // @see https://bugzilla.mozilla.org/show_bug.cgi?id=568313
    e.dataTransfer.setData('text/plain', '');
    e.dataTransfer.setData(
      'application/reactgridlayout',
      JSON.stringify({
        id: props.id,
        type: props.type,
        initialSize: props.initialSize,
        metadata: props.metadata,
      })
    );
  };

  const handleDragEnd = () => {
    onDragStop();
  };

  return (
    <div
      className="w-full h-full flex items-center justify-center"
      draggable
      unselectable="on"
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      {props.node}
    </div>
  );
};

export { RGDroppable };
